import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button, Grid } from "@material-ui/core";
import { useVideo } from '../../api/VideoProvider';
import { Send } from '@material-ui/icons';
import { pRecordTime, pStatus, pDonateSignButtonsOptions, pMediapipeHandDetected } from '../../utils/parameters';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReplayIcon from '@mui/icons-material/Replay';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import { CircularProgress } from '@mui/material';
import PanToolIcon from '@mui/icons-material/PanTool';
import { indigo } from '@mui/material/colors';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";


const useStyles = makeStyles((theme) => ({
    positionHandIcon_LEFT: {
        color: "red !important",
        transform: "translate(-65px, 20px) scale(1.5)",
    },
    positionHandIcon_RIGHT: {
        color: "blue !important",
        transform: "translate(-65px, 20px) scale(1.5)",
    },
  }));

export function DonateSignRecordingButton(props) {
    const { settings, enableDiscardButton, handleButtonStart, handleButtonDiscard, handleButtonRepeat, switchGalibo, positionHandIconButton, handDetectedArray, setHandDetected, activateMediapipe, pauseMediapipe } = props;
    const [timer, setTimer] = useState(pRecordTime.default);
    const { recTime, setRecTime, setFaceStatus, faceStatus } = useVideo();
    const [recordText, setRecordText] = useState('EMPEZAR');
    const { t } = useTranslation("global")
    const styles = useStyles();
    const [stepProgress, setStepProgress] = useState(settings.mode_remote);   // 10 o 20  25   // 10 o 20  25

    const [progressHandIconButton, setProgressHandIconButton] = useState({
        [pDonateSignButtonsOptions.NEXT]: 20,
        [pDonateSignButtonsOptions.REPEAT]: 20,
    });


    const THRESHOLD = 4
    // const [handDetectedArray, setHandDetectedArray] = useState(Array(10).fill(pMediapipeHandDetected.NONE));
    // const THRESHOLD = 7

    const getKeyByValue = (object, value) => {
        for (const key in object) {
          if (object[key] === value) {
            return key;
          }
        }
      };
    
    
    useEffect(() => {
        setStepProgress(settings.mode_remote);
    }, [settings.mode_remote]);


    function increaseProgressCounterButton (entry_param_hand_detected){ 
        const keyWithMatchingValue = getKeyByValue(positionHandIconButton, entry_param_hand_detected);
        switch (keyWithMatchingValue) {
            case pDonateSignButtonsOptions.NEXT:
                setProgressHandIconButton(prevState => ({
                    [pDonateSignButtonsOptions.NEXT]: prevState[pDonateSignButtonsOptions.NEXT] < 200 ? prevState[pDonateSignButtonsOptions.NEXT] + stepProgress : 200, 
                    [pDonateSignButtonsOptions.REPEAT]: 0
                }));
                break;
            case pDonateSignButtonsOptions.REPEAT:
                if (!disableRepeat()) {
                    setProgressHandIconButton(prevState => ({
                        [pDonateSignButtonsOptions.NEXT]: 0,
                        [pDonateSignButtonsOptions.REPEAT]: prevState[pDonateSignButtonsOptions.REPEAT] < 200 ? prevState[pDonateSignButtonsOptions.REPEAT] + stepProgress : 200
                    }));
                }
                break;
            default:
                setProgressHandIconButton(prevState => ({
                    [pDonateSignButtonsOptions.NEXT]: 0,
                    [pDonateSignButtonsOptions.REPEAT]: 0
                }));
                break;
        }

        if ((progressHandIconButton[pDonateSignButtonsOptions.NEXT]>99) && (progressHandIconButton[pDonateSignButtonsOptions.NEXT]<100 + stepProgress)){
            handleButtonStart()
        }
        if ((progressHandIconButton[pDonateSignButtonsOptions.REPEAT]>99) && (progressHandIconButton[pDonateSignButtonsOptions.REPEAT]<100 + stepProgress)){
            handleButtonRepeat()
        }

    }

    useEffect(() => {
        if(!activateMediapipe){
            setHandDetected(pMediapipeHandDetected.NONE);
            increaseProgressCounterButton(pMediapipeHandDetected.NONE);
        }
    }, [activateMediapipe])


    useEffect(() => {
        // console.log("🚀 ~ file: DonateSign.js:290 ~ useEffect ~ handDetectedArray:", handDetectedArray)
        if (!pauseMediapipe){

            let counters = { NONE: 0, RIGHT: 0, LEFT: 0, BOTH: 0 };
            for (let i = 0; i < handDetectedArray.length; i++) {
                if (handDetectedArray[i] === pMediapipeHandDetected.NONE) {
                    counters.NONE++;
                } else if (handDetectedArray[i] === pMediapipeHandDetected.LEFT) {
                    counters.LEFT++;
                } else if (handDetectedArray[i] === pMediapipeHandDetected.RIGHT) {
                    counters.RIGHT++;
                }else if (handDetectedArray[i] === pMediapipeHandDetected.BOTH) {
                    counters.BOTH++;
                }
            }

            for (let key in counters) {
                if (counters[key] > THRESHOLD) {
                    switch (key) {
                    case 'NONE':
                        setHandDetected(pMediapipeHandDetected.NONE);
                        increaseProgressCounterButton(pMediapipeHandDetected.NONE);
                        break;
                    case 'RIGHT':
                        setHandDetected(pMediapipeHandDetected.RIGHT);
                        increaseProgressCounterButton(pMediapipeHandDetected.RIGHT);
                        break;
                    case 'LEFT':
                        setHandDetected(pMediapipeHandDetected.LEFT);
                        increaseProgressCounterButton(pMediapipeHandDetected.LEFT);
                        break;
                    case 'BOTH':
                        setHandDetected(pMediapipeHandDetected.BOTH);
                        increaseProgressCounterButton(pMediapipeHandDetected.BOTH);
                        break;
                    default:
                        setHandDetected(pMediapipeHandDetected.NONE);
                        increaseProgressCounterButton(pMediapipeHandDetected.NONE);
                        break;
                    }
                    
                }
            }
        }else{
            setProgressHandIconButton(prevState => ({
                [pDonateSignButtonsOptions.NEXT]: 0,
                [pDonateSignButtonsOptions.REPEAT]: 0
            }));
            // console.log(handDetectedArray)
        }

        

        // setHandDetected(pMediapipeHandDetected.RIGHT);
    }, [handDetectedArray, pauseMediapipe]);
    

    /* MOB - Nav responsiveness*/
    const queryChecks = {
        textWidthLimit: useMediaQuery('(max-width:260px)'),
    }


    function disableRecord() {
        if ((faceStatus === pStatus.init || faceStatus === pStatus.rep || faceStatus === pStatus.rep_end) && faceStatus !== pStatus.error) {
            return false
        }
        return true
    }

    function disableRepeat() {
        if ((faceStatus === pStatus.rep || faceStatus === pStatus.rep_end) && faceStatus !== pStatus.error) {
            return false
        }
        return true
    }


    return (
        <Grid container className='sig_Home_ButtonsContainerInner'>          
            {props.children}    
            
            <Grid item>
                {activateMediapipe ? (  

                    <ButtonGroup style={{height: '45px',  minWidth: '150px'}} className='sig_Home_RecordingButtons' variant="contained" color="primary">
                        <Button data-tour='tourCam_5' onClick={handleButtonRepeat} disabled={disableRepeat()} endIcon={<ReplayIcon />}
                        startIcon={<CircularProgress style={{'color': indigo[900]}} variant="determinate" size={30} thickness={10} value={progressHandIconButton[pDonateSignButtonsOptions.REPEAT]} />}>
                            <PanToolIcon className={styles.positionHandIcon_LEFT} />
                            {t("sRecordComponent.repeatButton")}
                        </Button>
                    </ButtonGroup>
                ) : (
                    <ButtonGroup style={{height: '45px',  minWidth: '150px'}} className='sig_Home_RecordingButtons' variant="contained" color="primary">
                        <Button data-tour='tourCam_5' onClick={handleButtonRepeat} disabled={disableRepeat()} endIcon={<ReplayIcon />}>
                        {t("sRecordComponent.repeatButton")}
                        </Button>
                    </ButtonGroup>
                )}
            </Grid>

            {enableDiscardButton ? (
                <Grid item>
                        <ButtonGroup style={{height: '45px', minWidth: '150px'}} className='sig_Home_RecordingButtons' variant="contained" color="primary">
                        <Button data-tour="tourCam_7b" onClick={handleButtonDiscard} disabled={disableRepeat()} endIcon={<CancelScheduleSendIcon />} > {t("sRecordComponent.discardButton")} </Button>
                    </ButtonGroup>
                </Grid>
            ) : <></>
            }

            <Grid item>
                {/* <Button onClick={faceStatusShow}>fffffffffff</Button> */}
                {activateMediapipe ? (
                    <ButtonGroup style={{height: '45px',  minWidth: '150px'}} className='sig_Home_RecordingButtons' variant="contained" color="primary">
                        <Button data-tour='tourCam_5' onClick={handleButtonStart} disabled={disableRecord()} endIcon={<Send />}
                            startIcon={<CircularProgress style={{'color': indigo[900]}} variant="determinate" size={30} thickness={10} value={progressHandIconButton[pDonateSignButtonsOptions.NEXT]} />}>
                            <PanToolIcon className={styles.positionHandIcon_RIGHT} />
                            {(faceStatus === pStatus.init ? t("strButton.btn_start") : t("strButton.btn_send_continue"))}
                        </Button>
                    </ButtonGroup>
                ) : (
                    <ButtonGroup style={{height: '45px',  minWidth: '150px'}} className='sig_Home_RecordingButtons' variant="contained" color="primary">
                        <Button data-tour='tourCam_5' onClick={handleButtonStart} disabled={disableRecord()} endIcon={<Send />}>
                        {(faceStatus === pStatus.init ? t("strButton.btn_start") : t("strButton.btn_send_continue"))}
                        </Button>
                    </ButtonGroup>
                )}
            </Grid>
        </Grid >
    )
}